import { Injectable } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserInfo } from '../models/user-info';
import { CapUser } from '../models/cap-user';
import { AppConfig } from '../../config/app-config';
import { map, switchMap } from 'rxjs/operators';
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  userInfo: UserInfo;
  env = null;

  constructor(public http: HttpClient) {}

  getToken(): string {
    return localStorage.getItem('token');
  }

  getUserInfo(accessToken): Observable<UserInfo> {
    const getUserInfoFromToken: any = jwt_decode(accessToken);
    // console.log("userInfo123 =====>  "+JSON.stringify(this.userInfo));
    this.userInfo = {
      username: getUserInfoFromToken.preferredName,
      firstName: getUserInfoFromToken.firstName,
      lastName: getUserInfoFromToken.lastName,
      userCapNumber: getUserInfoFromToken.capNumber,
      isLoggedIn: true,
    };
    // this.userInfo.firstName = "getUserInfoFromToken.firstName;";
    // this.userInfo.lastName = getUserInfoFromToken.lastName;
    // this.userInfo.userCapNumber = getUserInfoFromToken.capNumber;
    console.log(
      'userInfo from auth service.ts=====>  ' + JSON.stringify(this.userInfo)
    );
    return observableOf(this.userInfo);

    // this.env = AppConfig.settings.apiServer.authDetails;
    // const meUrl = this.env.securityRemoteHost + this.env.userInfoUrl;
    // return this.http.get<CapUser>(meUrl, {
    //   headers: {
    //     'Content-Type': 'application/json'
    //   }}).pipe(map(res => {
    //     return <UserInfo> {
    //       username: res.UserName,
    //       firstName: res.FirstName,
    //       lastName: res.LastName,
    //       userCapNumber: res.UserMemberId,
    //       isLoggedIn: true,
    //     };
    // }));
  }
}
